import React from 'react';
import { useDispatch } from 'react-redux';
import { useModal } from '../_contexts';
import ReactTooltip from 'react-tooltip';
import { TimelineActions } from '../_actions';
import { IconButton } from '../_components';

export function TimelineOptions({ timeline }) {
  ReactTooltip.rebuild();
  const { openModal } = useModal();
  const dispatch = useDispatch();

  const handleTimelineOptionsClick = (ev) => {
    ev.preventDefault();
    openModal('newTimeline', { item: timeline });
  };

  const handleTimelineHideClick = (ev) => {
    ev.preventDefault();
    const updatedTimeline = { ...timeline, active: false };
    dispatch(TimelineActions.updateTimeline(updatedTimeline));
  };

  const tooltipContainer = 'timeline-tooltip-' + timeline._id;
  return (
    <span className="chronos-timeline-options">
      <ReactTooltip id={tooltipContainer} effect="solid" place="top" />
      <IconButton
        icon="far fa-cog"
        onClick={handleTimelineOptionsClick}
        iconOnly
        data-tip="Edit"
        data-for={tooltipContainer}
      />
      <IconButton
        icon="far fa-eye-slash"
        onClick={handleTimelineHideClick}
        iconOnly
        data-tip="Hide"
        data-for={tooltipContainer}
      />
    </span>
  );
}
